import { render, staticRenderFns } from "./VantPriceCustom.vue?vue&type=template&id=7b43f52b&scoped=true&"
import script from "./VantPriceCustom.vue?vue&type=script&lang=js&"
export * from "./VantPriceCustom.vue?vue&type=script&lang=js&"
import style0 from "./VantPriceCustom.vue?vue&type=style&index=0&id=7b43f52b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b43f52b",
  null
  
)

export default component.exports